export default __webpack_public_path__ + "static/media/map-icon-white.3c6d4e98.svg";